import { DropDownComponent } from "./DropdownComponent";

export const Dropdown = DropDownComponent;
